<div fxLayout="column" fxFlex>
	<h2 mat-dialog-title>{{ 'LABEL_AUTHENTICATION_REQUIRED' | translate: { type: otpType } }}</h2>

	<div fxFlex="100%">
		<div fxLayout="column" fxLayoutAlign="space-evenly stretch" fxLayoutGap="10px" fxFlex="100%">
			<form fxFlex [formGroup]="otpForm" (ngSubmit)="otpForm.valid && validate(otpForm.value)" fxLayout="column" autocomplete="off" autocorrect="off"
			fxLayoutGap="10px" novalidate class="padding-15">
				<mat-label class="mat-subheading-1">
					<span>
						{{ 'MSG_OTP_SENT' | translate: { type: otpType, mask: maskedRecipient, checkLabel: checkLabelMap[data.type] ?? 'email' } }}
					</span>
				</mat-label>

				<!-- <mat-form-field>
					<input id="id_otp_otp" matInput [placeholder]="'LABEL_ONE_TIME_PIN' | translate" formControlName="otp" autocomplete="off" required>
					<mat-error *ngIf="otpForm.controls['otp'].hasError('required')">
						{{ 'MSG_ERROR_OTP_REQUIRED' | translate }}
					</mat-error>
				</mat-form-field> -->

				<div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="center center">
                    <mat-form-field fxFlex="20px">
                        <input id="id_otp_otp1" class="text-center" matInput placeholder="#" inputmode="numeric" (keydown)="focusNextInput($event, 1)" (beforeinput)="handleBeforeInput($event, 1)" formControlName="otp1" #inputElement1 (paste)="cascadePaste($event)" autocomplete="off" maxlength="1">
                    </mat-form-field>
                    <mat-form-field fxFlex="20px">
                        <input id="id_otp_otp2" class="text-center" matInput placeholder="#" inputmode="numeric" (keydown)="focusNextInput($event, 2)" (beforeinput)="handleBeforeInput($event, 2)" formControlName="otp2" #inputElement2 autocomplete="off" maxlength="1">
                    </mat-form-field>
                    <mat-form-field fxFlex="20px">
                        <input id="id_otp_otp3" class="text-center" matInput placeholder="#" inputmode="numeric" (keydown)="focusNextInput($event, 3)" (beforeinput)="handleBeforeInput($event, 3)" formControlName="otp3" #inputElement3 autocomplete="off" maxlength="1">
                    </mat-form-field>
                    <mat-form-field fxFlex="20px">
                        <input id="id_otp_otp4" class="text-center" matInput placeholder="#" inputmode="numeric" (keydown)="focusNextInput($event, 4)" (beforeinput)="handleBeforeInput($event, 4)" formControlName="otp4" #inputElement4 autocomplete="off" maxlength="1">
                    </mat-form-field>
                    <mat-form-field fxFlex="20px">
                        <input id="id_otp_otp5" class="text-center" matInput placeholder="#" inputmode="numeric" (keydown)="focusNextInput($event, 5)" (beforeinput)="handleBeforeInput($event, 5)" formControlName="otp5" #inputElement5 autocomplete="off" maxlength="1">
                    </mat-form-field>
                    <mat-form-field fxFlex="20px">
                        <input id="id_otp_otp6" class="text-center" matInput placeholder="#" inputmode="numeric" (keydown)="focusNextInput($event, 6)" (beforeinput)="handleBeforeInput($event, 6)" formControlName="otp6" #inputElement6 autocomplete="off" maxlength="1">
                    </mat-form-field>
                </div>

				<mat-error class="mat-warn-color mat-subheading-1" *ngIf="errorMessage">
					{{errorMessage}}
				</mat-error>

				<mat-label class="mat-subheading-1">
					<span>
						{{ 'LABEL_DID_NOT_RECEIVE_OTP' | translate }}
					</span>
					<span class="mat-subheading-1" [class.mat-primary-color]="otpCountdown <= 0 && !requesting" (click)="requestOtp()" [disabled]="otpCountdown > 0 || requesting">
						{{ (requesting ? 'LABEL_SENDING' : 'LABEL_RESEND_OTP') | translate }} {{ (otpCountdown > 0 ? '(' + otpCountdown + ')' : '' ) }}
					</span>
				</mat-label>

				<div fxFlex fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="end">
					<button mat-button [disabled]="isConfirming" (click)="dialogRef.close(null)" type="button">{{ 'LABEL_CANCEL' | translate }}</button>
					<button mat-button *ngIf="skippable" (click)="dialogRef.close(false)" type="button">{{ 'LABEL_SKIP' | translate }}</button>
					<button color="primary" [class.spinner]="isConfirming" [disabled]="isConfirming" mat-raised-button type="submit">
						<div fxLayout fxLayoutAlign="center center">
							<span class="padding-right-2 text-primary-color">
								{{ (isConfirming ? 'LABEL_CONFIRMING_OTP' : 'LABEL_CONFIRM_OTP') | translate }}
							</span>
							<mat-spinner [diameter]="20" color="primary" *ngIf="isConfirming"></mat-spinner>
						</div>
					</button>
				</div>
			</form>
		</div>
	</div>

</div>